import { useSkillsStore } from '../store';

export function useSkillPrefs(skillId: string) {
  const skill = useSkillsStore((s) => s.skills.find((sk) => sk.id === skillId));
  const patchPrefs = useSkillsStore((s) => s.actions.patchPrefs);

  const toggleContext = (contextName: string, enabled: boolean) =>
    patchPrefs(skillId, { contexts: { [contextName]: enabled } });

  const updateSetting = (key: string, value: number) =>
    patchPrefs(skillId, { settings: { [key]: value } });

  return { skill, toggleContext, updateSetting };
}
